import React, { Component } from 'react'
import queryString from 'query-string'
import Auth from '../../Auth'

const auth = new Auth();

export class AliPay extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            content: ""
        }
    }



    componentDidMount() {
        const parsed = queryString.parse(window.location.search);
        console.log(parsed)

        if (!parsed.orderId)
            this.props.history.push("/")

        const options = {
            'headers': {
                ...auth.options()
            }
        }

        fetch('/api/Payment/GetAliPayRedirect?orderId=' + parsed.orderId, {
            ...options,
            method: 'GET'
        }).then(
            Response => {
                console.log(Response.status)

                if (Response.ok) {
                    return Response.text();
                }

                if (Response.status === 401) {
                    auth.signOut();
                    this.props.history.push("/Login")
                }

                if (Response.status === 404) {
                    this.props.history.goBack();
                }
                throw new Error('服务器错误');
            }

        ).then(
            (text) => {
                this.setState({ content: text }, () => {
                    window.document.forms['submit'].submit();
                });
            }
        ).catch(error => {
            console.error(error);
        })

    }

    render() {
        return (
            <div>
                <h3>支付宝支付，跳转中...</h3>

                <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
            </div>
        )
    }
}

export default AliPay